import { PropsWithChildren, JSX } from 'react';
import classes from './ListSection.module.scss';

export const ListSection = (props: PropsWithChildren): JSX.Element => (
    <div className={classes.container}>{props.children}</div>
);
